// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

document.addEventListener('DOMContentLoaded', function () {
  const teamLink = document.getElementById('navbarDropdownTeam');

  if (teamLink) {
    const dropdown = new bootstrap.Dropdown(teamLink);

    teamLink.addEventListener('click', function (e) {
      // Prüfen, ob Shift, Ctrl oder Meta gedrückt sind (für normalen Link-Klick)
      if (e.ctrlKey || e.metaKey || e.shiftKey) return;

      e.preventDefault(); // Navigation unterbrechen
      dropdown.toggle(); // Dropdown öffnen/schließen

      // Wenn du willst, kannst du hier nach kurzer Zeit zur Seite navigieren:
      // window.location.href = teamLink.href;
    });
  }
});